/* Joyeux Marché — ajout en un clic depuis les suggestions du tiroir panier (jm-cart-upsell). */
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', async (e) => {
  const b = e.target.closest && e.target.closest('[data-jm-upsell-add]');
  if (!b) return;
  e.preventDefault();
  if (b.getAttribute('aria-busy') === 'true') return;
  b.setAttribute('aria-busy', 'true');
  const label = b.textContent;
  b.textContent = '…';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const id = Number(b.getAttribute('data-jm-upsell-add'));
  const deferred = CartLinesUpdateEvent.createPromise();
  b.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: deferred.promise }));
  try {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: 'cart-drawer-section' })
    }).then((r) => r.json());
    const ajax = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajax),
      detail: { items: ajax.items, source: 'jm-upsell', sourceId: 'jm-upsell', itemCount: 1, sections: res.sections || {}, didError: Boolean(res.status) }
    });
    if (res.status) { b.textContent = label; b.removeAttribute('aria-busy'); }
  } catch (err) {
    deferred.reject(err);
    location.href = root + 'cart';
  }
});
